var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "imageCarousel",
            size: "xl",
            "content-class": "menu-bg-blue-transparent-modal ic-modal",
            centered: "",
            "hide-footer": "",
            title: "Field Images",
          },
          on: {
            show: function ($event) {
              return _vm.openModal()
            },
          },
          scopedSlots: _vm._u([
            {
              key: "modal-header",
              fn: function ({ close }) {
                return [
                  _c("div", { staticClass: "ic-header" }, [
                    _c("div", { staticClass: "ic-header-left" }, [
                      _c(
                        "span",
                        { staticClass: "ic-header-icon" },
                        [_c("fa", { attrs: { icon: ["fas", "images"] } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "ic-header-titles" }, [
                        _c("span", { staticClass: "ic-header-title" }, [
                          _vm._v("Field Images"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "ic-header-sub" },
                          [
                            _vm.dataLoaded && _vm.images.length > 0
                              ? [
                                  _vm._v(
                                    _vm._s(_vm.count) +
                                      " image" +
                                      _vm._s(_vm.count === 1 ? "" : "s") +
                                      " available"
                                  ),
                                ]
                              : [_vm._v("DPR field imagery gallery")],
                          ],
                          2
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "ic-close",
                        attrs: { title: "Close" },
                        on: {
                          click: function ($event) {
                            return close()
                          },
                        },
                      },
                      [_c("fa", { attrs: { icon: ["fas", "times"] } })],
                      1
                    ),
                  ]),
                ]
              },
            },
          ]),
        },
        [
          _vm._v(" "),
          _c("div", { staticClass: "ic-body" }, [
            _c(
              "div",
              { staticClass: "ic-filter-panel" },
              [
                _c("MMP_QueryConstructor", {
                  attrs: {
                    comp: "DPR_FI",
                    getConditions: _vm.existingConditions,
                    fieldImages: _vm.allImages,
                  },
                  on: {
                    filter_images: function ($event) {
                      return _vm.filterImages($event)
                    },
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "ic-stage" },
              [
                _vm.images.length < 1 && _vm.dataLoaded
                  ? _c("div", { staticClass: "empty-state" }, [
                      _c(
                        "span",
                        { staticClass: "empty-state-icon" },
                        [_c("fa", { attrs: { icon: ["fas", "images"] } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "empty-state-text" }, [
                        _vm._v("No images found"),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "empty-state-sub" }, [
                        _vm._v("Try adjusting the filters above."),
                      ]),
                    ])
                  : !_vm.dataLoaded
                  ? _c("div", { staticClass: "loading-state" }, [
                      _c("span", {
                        staticClass: "spinner-border loading-spinner",
                        attrs: { role: "status" },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "loading-text" }, [
                        _vm._v("Loading field images…"),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.dataLoaded && _vm.images.length > 0
                  ? _c(
                      "b-carousel",
                      {
                        attrs: {
                          id: "dpr_image_carousel",
                          controls: "",
                          indicators: "",
                          interval: 10000,
                        },
                        model: {
                          value: _vm.currentSlide,
                          callback: function ($$v) {
                            _vm.currentSlide = $$v
                          },
                          expression: "currentSlide",
                        },
                      },
                      _vm._l(_vm.chunkedImages, function (chunk, index) {
                        return _c("b-carousel-slide", {
                          key: index,
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "img",
                                fn: function () {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "slide" },
                                      _vm._l(chunk, function (img, imgIndex) {
                                        return _c(
                                          "div",
                                          {
                                            key: imgIndex,
                                            staticClass: "img-container",
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "img-frame" },
                                              [
                                                _c("img", {
                                                  staticClass: "img card-item",
                                                  attrs: {
                                                    src:
                                                      _vm.annotation +
                                                      img.image,
                                                    alt: "Open full image",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.openImageInNewTab(
                                                        $event,
                                                        img
                                                      )
                                                    },
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "img-zoom-hint",
                                                  },
                                                  [
                                                    _c("fa", {
                                                      attrs: {
                                                        icon: ["fas", "expand"],
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "img-text-container",
                                              },
                                              [
                                                img.dpr_id &&
                                                img.upload_date &&
                                                img.username
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "text-container",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "info-row",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "info-label",
                                                              },
                                                              [_vm._v("DPR ID")]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "info-value",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    img.dpr_id
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "info-row",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "info-label",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Uploaded On"
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "info-value",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    img.upload_date.split(
                                                                      "T"
                                                                    )[0]
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "info-row",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "info-label",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Uploaded By"
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "info-value",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    img.username
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                          ]
                                        )
                                      }),
                                      0
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      }),
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }